import React, { ReactNode } from 'react';
import styles from '../../styles.module.css';
import MainIcons from '@/icons/main';
import Button from '@/components/common/Button';
import { downloadFunction } from '@/commonTypes';

export default function DownloadButton({
  onClick,
  type = 'download',
  children,
  loading,
  className = '',
}: {
  onClick?: any;
  type?: 'download' | 'print';
  children?: ReactNode;
  loading?: boolean;
  className?: string;
}) {
  return (
    <Button
      className={`${styles.button} ${className}`}
      onClick={onClick}
      type="button"
      loading={loading ? true : false}
    >
      {children ? (
        children
      ) : (
        <>
          {type == 'download' && (
            <MainIcons.downloadIcon fill="var(--brand-deep)" width="20px" height="20px" />
          )}
          {type == 'print' && (
            <MainIcons.printIcon fill="var(--brand-deep)" width="20px" height="20px" />
          )}
        </>
      )}
    </Button>
  );
}
